<div class="list-page" style="max-width: 2000px; padding: 1em">
  <h1 class="light-blue-text">Holvi-integraatiot</h1>

  <mat-tab-group>
    <mat-tab label="Ennakkoverolaskut">
      <form>
        <div style="margin: 2em">
          <h2 class="light-blue-text">Ennakkoverolaskujen luonti ja lähetys</h2>
          <div style="padding-bottom: 20px"></div>
          <mat-form-field style="max-width: 200px">
            <!-- [min]="annaMinimiDate(jakso)" -->
            <mat-label>Laskujen kuukausi</mat-label>
            <input matInput monthPicker #monthPicker [matDatepicker]="picker" [formField]="lomake.kuukausi" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            @if (onkoVirhe(lomake.kuukausi, 'required') && (lomake.kuukausi().dirty() || lomake.kuukausi().touched())) {
              <mat-error>Kuukausi puuttuu</mat-error>
            }
            <mat-datepicker #picker></mat-datepicker> </mat-form-field
          ><br />
          <app-primary-button (click)="luoEnnakkoverolaskut()" actionId="Luo ennakkoverolaskut, holvi" [actionContext]="$any(lomake().value())" styles="margin-right: 1em;">Luo laskut</app-primary-button>
          <app-primary-button (click)="lahetaEnnakkoverolaskut()" actionId="Lähetä ennakkoverolaskut, holvi" [actionContext]="$any(lomake().value())" styles="margin-right: 1em;">Lähetä laskut</app-primary-button>
        </div>
      </form>
      <div>
        <h3>Lähetetään</h3>
        @for (lahetettava of lahetettavatEnnakkoverolaskutObservable | async; track lahetettava) {
          <div>
            <pre>
Asiakas: {{ lahetettava.asiakas }}
              Viitenumero: "{{ lahetettava?.lahetysdata?.viitenumero }}", Summa: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.summa }}", Eräpäivä: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.erapaiva | lokaalipvm | async }}", Operaattori: "{{ lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja }}", Osoite: "{{
                lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja
              }}"
            Lopputulos: "{{ lahetettava?.lahetysdata?.tila }}"</pre>
          </div>
        }

        <h3>Lähetetty jo (Ei lähetetä uudelleen)</h3>
        @for (lahetettava of lahetettyJoEnnakkoverolaskutObservable | async; track lahetettava) {
          <div>
            <pre>
Asiakas: {{ lahetettava.asiakas }}
              Viitenumero: "{{ lahetettava?.lahetysdata?.viitenumero }}", Summa: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.summa }}", Eräpäivä: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.erapaiva | lokaalipvm | async }}", Operaattori: "{{ lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja }}", Osoite: "{{
                lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja
              }}"
            Lopputulos: "{{ lahetettava?.lahetysdata?.tila }}"</pre>
          </div>
        }

        <h3>Ei lähetetä</h3>
        @for (lahetettava of eiLahetettavatEnnakkoverolaskutObservable | async; track lahetettava) {
          <div>
            <pre>
Asiakas: {{ lahetettava.asiakas }}
              Viitenumero: "{{ lahetettava?.lahetysdata?.viitenumero }}", Summa: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.summa }}", Eräpäivä: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.erapaiva | lokaalipvm | async }}", Operaattori: "{{ lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja }}", Osoite: "{{
                lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja
              }}"
            Lopputulos: "{{ lahetettava?.lahetysdata?.tila }}"</pre>
          </div>
        }

        <h3>Lähetyshistoria</h3>
        @for (lahetettava of historiaEnnakkoverolaskutObservable | async; track lahetettava) {
          <div>
            <pre>
Asiakas: {{ lahetettava.asiakas }}
              Viitenumero: "{{ lahetettava?.lahetysdata?.viitenumero }}", Summa: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.summa }}", Eräpäivä: "{{ lahetettava?.lahetysdata?.ennakkoveronEra?.erapaiva | lokaalipvm | async }}", Operaattori: "{{ lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja }}", Osoite: "{{
                lahetettava?.lahetysdata?.sahkoinenLaskutusosoite?.sahkoinenValittaja
              }}"
            Lopputulos: "{{ lahetettava?.lahetysdata?.tila }}"</pre>
          </div>
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
